module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays-img-2.39e467ac.jpeg";